<template>
  <div class="search-loading-mask" v-if="visible" :style="customStyle">
    <div class="search-container">
      <div class="search-wrap">
        <!-- 优化后的现代化卡片文档样式 -->
        <div class="modern-document">
          <div class="document-header">
            <div class="doc-icon">
              <div class="icon-inner"></div>
            </div>
            <div class="doc-title-wrapper">
              <div class="doc-title"></div>
              <div class="doc-subtitle"></div>
            </div>
          </div>
          <div class="document-content">
            <div class="content-line" v-for="i in 5" :key="i"></div>
          </div>
          <div class="document-footer">
            <div class="footer-line"></div>
            <div class="footer-tags">
              <div class="tag" v-for="i in 3" :key="'tag'+i"></div>
            </div>
          </div>
        </div>

        <!-- 优化后的放大镜 -->
        <div class="magnifier-true">
          <div class="glass">
            <div class="reflection"></div>
            <div class="crosshair"></div>
            <div class="lens-effect"></div>
          </div>
          <div class="handle"></div>
        </div>
      </div>

      <p class="loading-text">{{ text }}</p>

      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress"></div>
          <div class="progress-highlight"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchLoading",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: "正在搜索，请稍候..."
    },
    customStyle: {
      type: Object,
      default: () => ({
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%"
      })
    }
  }
};
</script>

<style scoped>
.search-loading-mask {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 99;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
  Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  transition: all 0.3s ease;
}

.search-container {
  width: 340px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.search-wrap {
  width: 260px;
  height: 200px;
  position: relative;
}

/* 优化后的现代化卡片文档样式 */
.modern-document {
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  padding: 18px;
  display: flex;
  flex-direction: column;
  animation: documentFloat 4s ease-in-out infinite;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.document-header {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}

.doc-icon {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  border-radius: 6px;
  margin-right: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 2px rgba(255,255,255,0.2);
}

.icon-inner {
  width: 16px;
  height: 16px;
  background: #1e88e5;
  border-radius: 3px;
  opacity: 0.7;
}

.doc-title-wrapper {
  flex: 1;
}

.doc-title {
  width: 70%;
  height: 12px;
  background: #e3f2fd;
  border-radius: 4px;
  margin-bottom: 6px;
  animation: titlePulse 3s ease-in-out infinite;
}

.doc-subtitle {
  width: 50%;
  height: 8px;
  background: #f0f7ff;
  border-radius: 4px;
}

.document-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 4px 0;
}

.content-line {
  height: 8px;
  background: #f5f9ff;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  animation: linePulse 2.5s ease-in-out infinite;
  animation-delay: calc(var(--i) * 0.15s);
}

.content-line::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg,
  rgba(255,255,255,0) 0%,
  rgba(255,255,255,0.9) 50%,
  rgba(255,255,255,0) 100%);
  animation: shine 2.5s ease-in-out infinite;
  animation-delay: calc(var(--i) * 0.15s);
}

.content-line:nth-child(1) { width: 95%; --i: 1; }
.content-line:nth-child(2) { width: 90%; --i: 2; }
.content-line:nth-child(3) { width: 85%; --i: 3; }
.content-line:nth-child(4) { width: 70%; --i: 4; }
.content-line:nth-child(5) { width: 80%; --i: 5; }

.document-footer {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}

.footer-line {
  height: 6px;
  width: 40%;
  background: #e3f2fd;
  border-radius: 3px;
  margin-bottom: 12px;
  animation: footerPulse 3s ease-in-out infinite;
}

.footer-tags {
  display: flex;
  gap: 8px;
}

.tag {
  width: 40px;
  height: 6px;
  background: #e3f2fd;
  border-radius: 3px;
  animation: tagPulse 3s ease-in-out infinite;
  animation-delay: calc(var(--i) * 0.2s);
}

.tag:nth-child(1) { --i: 1; }
.tag:nth-child(2) { --i: 2; }
.tag:nth-child(3) { --i: 3; }

/* 优化后的放大镜样式 */
.magnifier-true {
  position: absolute;
  width: 65px;
  height: 65px;
  left: 25px;
  top: 25px;
  animation: containerMove 6s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  z-index: 10;
}

.glass {
  width: 100%;
  height: 100%;
  border: 3px solid #1e88e5;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  box-shadow:
      0 4px 15px rgba(30, 136, 229, 0.3),
      inset 0 0 10px rgba(30, 136, 229, 0.2);
  position: relative;
  z-index: 2;
  backdrop-filter: blur(1px);
}

.reflection {
  position: absolute;
  width: 25px;
  height: 25px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  top: 10px;
  left: 10px;
  filter: blur(2px);
  animation: reflectionMove 5s ease-in-out infinite;
}

.lens-effect {
  position: absolute;
  width: 80%;
  height: 80%;
  border-radius: 50%;
  top: 10%;
  left: 10%;
  background: radial-gradient(circle at 30% 30%,
  rgba(255,255,255,0.8) 0%,
  rgba(200,230,255,0.4) 50%,
  rgba(100,180,255,0.1) 100%);
}

.crosshair {
  position: absolute;
  width: 100%;
  height: 100%;
}

.crosshair::before,
.crosshair::after {
  content: "";
  position: absolute;
  background: rgba(30, 136, 229, 0.25);
}

.crosshair::before {
  width: 2px;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
}

.crosshair::after {
  height: 2px;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
}

.handle {
  position: absolute;
  width: 45px;
  height: 12px;
  background: linear-gradient(to right, #1e88e5, #42a5f5);
  border-radius: 6px;
  transform: rotate(45deg);
  transform-origin: left center;
  right: -25px;
  bottom: 10px;
  box-shadow:
      2px 2px 6px rgba(0, 0, 0, 0.1),
      inset -1px -1px 2px rgba(0,0,0,0.1);
  z-index: 1;
  animation: handleFlex 2.5s ease-in-out infinite;
}

.loading-text {
  font-size: 16px;
  color: #0d47a1;
  font-weight: 500;
  margin: 40px 0 0;
  text-align: center;
  animation: textFade 3s ease-in-out infinite;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.progress-container {
  width: 110%;
  margin-top: 20px;
}

.progress-bar {
  width: 100%;
  height: 5px;
  background: rgba(21, 101, 192, 0.1);
  border-radius: 3px;
  overflow: hidden;
  position: relative;
}

.progress {
  height: 100%;
  width: 30%;
  background: linear-gradient(90deg, #1e88e5, #64b5f6);
  border-radius: 3px;
  position: absolute;
  animation: progressLoad 2.5s ease-in-out infinite;
}

.progress-highlight {
  position: absolute;
  height: 100%;
  width: 20%;
  background: rgba(100, 180, 255, 0.4);
  border-radius: 3px;
  animation: progressPulse 2.5s ease-in-out infinite;
}

/* 优化后的动画 */
@keyframes containerMove {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  15% {
    transform: translate(40px, 15px) rotate(5deg);
  }
  30% {
    transform: translate(80px, 30px) rotate(-3deg);
  }
  45% {
    transform: translate(120px, 20px) rotate(2deg);
  }
  60% {
    transform: translate(80px, 45px) rotate(-5deg);
    opacity: 0.9;
  }
  75% {
    transform: translate(40px, 30px) rotate(3deg);
  }
}

@keyframes reflectionMove {
  0%, 100% { transform: translate(0, 0); opacity: 0.8; }
  50% { transform: translate(10px, 10px); opacity: 0.6; }
}

@keyframes handleFlex {
  0%, 100% { transform: rotate(45deg) scaleX(1); }
  50% { transform: rotate(45deg) scaleX(0.95); }
}

@keyframes documentFloat {
  0%, 100% {
    transform: translateY(0) rotateX(0deg) scale(1);
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  }
  50% {
    transform: translateY(-8px) rotateX(2deg) scale(1.02);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
  }
}

@keyframes titlePulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.8; }
}

@keyframes linePulse {
  0%, 100% { background: #f5f9ff; }
  50% { background: #e3f2fd; }
}

@keyframes shine {
  0% { transform: translateX(-150%); }
  100% { transform: translateX(250%); }
}

@keyframes footerPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

@keyframes tagPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

@keyframes progressLoad {
  0% { left: -30%; width: 30%; }
  50% { left: 50%; width: 40%; }
  100% { left: 100%; width: 30%; }
}

@keyframes progressPulse {
  0% { left: -20%; opacity: 0; }
  20% { opacity: 1; }
  80% { opacity: 1; }
  100% { left: 100%; opacity: 0; }
}

@keyframes textFade {
  0%, 100% {
    opacity: 1;
    transform: translateY(0);
  }
  50% {
    opacity: 0.9;
    transform: translateY(-2px);
  }
}
</style>



// WEBPACK FOOTER //
// searchLoaing.vue?032bd9c8